// extracted by mini-css-extract-plugin
module.exports = {"bannervideo":"bannervideo_bannervideo__dgi4x"};